// START_MODULE external_link_icon
// START_CONTRACT
// PURPOSE: Mark links that open a destination outside the Tomsk Data Science site.
// OPERATIONAL_CONTEXT: Rendered inline after external-link labels.
// CONTRACT: Draw a compact north-east arrow while inheriting the surrounding text color.
// KEYWORDS: external-link, icon, accessibility
// COMPLEXITY: 1
// END_CONTRACT
import React from 'react';

import { IconProps } from './interfaces/iconProps';

const ExternalLinkIcon: React.FC<IconProps> = ({ size = 16, color = 'currentColor', ...restProps }) => (
  <svg
    {...restProps}
    aria-hidden="true"
    fill="none"
    height={`${size}px`}
    viewBox="0 0 16 16"
    width={`${size}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 11 11 5M6.5 5H11v4.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.6"
    />
  </svg>
);

export default ExternalLinkIcon;

// END_MODULE external_link_icon
